import { render, staticRenderFns } from "./LandingCmp.vue?vue&type=template&id=4b6deb58&"
import script from "./LandingCmp.vue?vue&type=script&lang=js&"
export * from "./LandingCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports